namespace advisorop.services {
    "use strict";
    export class GeneralService {

        static $inject = ["$http", "$q", "$rootScope", "authInterceptor"];
        constructor(private $http: ng.IHttpService, private $q: ng.IQService,
            private $rootScope: ng.IRootScopeService,
            private authInterceptor: AuthInterceptor) {
            //console.log(`General service initialised. unauthorizedMsgSeen: ${this.authInterceptor.unauthorizedMessageSeen}`);
        }

        toUTCDateString(dateString: string): string {
            if (!dateString) {
                return;
            }
            if (dateString.indexOf('Z') === -1 && dateString.indexOf('+') === -1) {
                return dateString += 'Z';
            }
            return dateString;
        }

        // Validation
        validateForm(frm: ng.IFormController): boolean {
            if (!frm) {
                console.log("Form is not defined!");
                return false;
            }


            if (frm && frm.$invalid) {
                for (var el in frm) {
                    if (el.indexOf("$") < 0 && el != "form") {
                        //console.log("Validating:", el);
                        try {
                            frm[el].$setTouched();
                        } catch (e) {
                            console.log(`Error during validation call of element ${el}`, e);
                        }
                        $(`[name='${el}']`).blur();
                        if (!frm[el].$valid)
                            console.log("###### INVALID ELEMENT IS:", frm[el].$name, frm[el].$error);
                        //else 
                        //    console.log("###### ELEMENT IS VALID:", frm[el]);
                    }
                    //console.log(`Done with ${el}`, frm);
                }
                return false;
            }
            return true;
        };

        //// Validate from a list of names only
        //validateSpecific(frm: ng.IFormController, items: string[]): boolean {
        //    var ret: boolean = true;

        //    if (!frm) {
        //        console.log("Form is not defined!");
        //        return false;
        //    } else {
        //        console.log("Validating Form:", frm);
        //    }


        //    if (frm && frm.$invalid) {
        //        for (var el in frm) {
        //            if (items.indexOf(el) > -1) {
        //                console.log("Validating:", el);
        //                try {
        //                    frm[el].$setTouched();
        //                } catch (e) {
        //                    console.log(`Error during validation call of element ${el}`, e);
        //                }
        //                $(`[name='${el}']`).blur();
        //                if (!frm[el].$valid) {
        //                    console.log("###### INVALID ELEMENT IS:", frm[el].$name, frm[el].$error);
        //                    ret = false;
        //                }
        //                //else 
        //                //    console.log("###### ELEMENT IS VALID:", frm[el]);
        //                console.log(`Done with ${el}`, frm);
        //            }
        //        }
        //        return ret;
        //    }
        //    return true;
        //};

        //// Validate from a list of names only
        //validateFormSpecificItem(frm: ng.IFormController, item: string): boolean {
        //    var ret: boolean = true;

        //    if (!frm) {
        //        console.log("Form is not defined!");
        //        return false;
        //    } else {
        //        console.log("Validating Form:", frm);
        //    }


        //    if (frm && frm.$invalid) {
        //        for (var el in frm) {
        //            if (item == el) {
        //                console.log("Validating:", el);
        //                try {
        //                    frm[el].$setTouched();
        //                } catch (e) {
        //                    console.log(`Error during validation call of element ${el}`, e);
        //                }
        //                $(`[name='${el}']`).blur();
        //                if (!frm[el].$valid) {
        //                    console.log("###### INVALID ELEMENT IS:", frm[el].$name, frm[el].$error);
        //                    ret = false;
        //                }
        //                //else 
        //                //    console.log("###### ELEMENT IS VALID:", frm[el]);
        //                console.log(`Done with ${el}`, frm);
        //            }
        //        }
        //        return ret;
        //    }
        //    return true;
        //};

        // Error messages
        showError(errResponse: any): void {
            // show error message only if there is no problem with user authorisation
            console.log(`UnauthorizedMessageSeen [${this.authInterceptor.unauthorizedMessageSeen}]: `, errResponse);
            if (!this.authInterceptor.unauthorizedMessageSeen) {
                toastr.error(`Error: ${errResponse.data}`);
            } else {
                console.log(`*Error: `, errResponse);
            }
        }
        showErrorWithMessage(message: string, errResponse: any): void {
            // show error message only if there is no problem with user authorisation
            if (!this.authInterceptor.unauthorizedMessageSeen) {
                toastr.error(`${message} Error: ${errResponse.data}`);
            } else {
                console.log(`**Error: `, errResponse);
            }
        }

        getAlertString(id: number, name: string): string {
            return id + '#' + name + ';';
        }

        // /////////////////////////////////////////////////////////////
        // Alerts
        getAlerts(showArchived: boolean, showInformationalMessages: boolean, householdId?: number,
            accountGroupId?: number, accountId?: number,
            investorId?: number, extended: boolean = false,
            getRule: domains.AlertsGetRule = domains.AlertsGetRule.SHOW_ALL): ng.IHttpPromise<Array<domains.IAlertLog>> {

            if (!householdId) householdId = 0;
            if (!accountGroupId) accountGroupId = 0;
            if (!accountId) accountId = 0;
            if (!investorId) investorId = 0;


            return this.$http.get(`/api/general/getalerts/${showArchived}/${showInformationalMessages}/${householdId}/${accountGroupId}/${accountId}/${investorId}/${extended}/${getRule}`);
        };

        getAlert(id: number): ng.IHttpPromise<domains.IAlertLog> {
            return this.$http.get("/api/general/getalert/" + id);
        };

        archiveAlert(model: domains.IAlertLog): ng.IHttpPromise<domains.IAlertLog> {
            return this.$http.put(`api/general/archivealert/${model.id}`, null);
        };

        claimAlert(model: domains.IAlertLog): ng.IHttpPromise<domains.IAlertLog> {
            return this.$http.put(`api/general/claimalert/${model.id}`, null);
        };

        releaseAlert(model: domains.IAlertLog): ng.IHttpPromise<domains.IAlertLog> {
            return this.$http.put(`api/general/releasealert/${model.id}`, null);
        };

        getRoles(): ng.IHttpPromise<Array<domains.identity.IRole>> {
            return this.$http.get("/api/general/getroles");
        }

        /// Whether the menus show the RMD TRACKER (NEW) link. A setting per environment.
        getRmdTrackerMenuVisible(): ng.IHttpPromise<boolean> {
            return this.$http.get("/api/general/getRmdTrackerMenuVisible");
        }

        createAlertOrTask(alert: domains.IAlertLog): ng.IHttpPromise<domains.IAlertLog> {
            return this.$http.post(`/api/general/createalerttask`, alert);
        }

        getAuditAccountInformation(accountId: number): ng.IHttpPromise<Array<domains.IAlertLog>> {
            return this.$http.get(`/api/general/getauditaccountinformation/` + accountId);
        };

        setAlertCounters(counters: domains.IAlertCounters) {
            localStorage.setItem("alertCounters", JSON.stringify(counters));
        }

        getAlertCounters(): domains.IAlertCounters {
            return JSON.parse(localStorage.getItem("alertCounters"));
        }

        refreshAlertCounters(): void {
            this.$http.get(`/api/general/getalertscount`)
                .then(data => {
                    localStorage.setItem("alertCounters", JSON.stringify(data.data));
                    this.$rootScope.$broadcast("alertCounterChanged");
                }, err => this.showError(err));
        }

        checkLovVersion(): boolean {
            var version = localStorage.getItem(constants.LS_VERSION);
            var lovVersion = localStorage.getItem(constants.LS_LOV_VERSION);

            if (!version || version === constants.DEFAULT_VERSION) {
                // return true, and in the background try to get app version
                //console.log(`Checking app version. Current value is ${version}`);
                this.loadAdvisorOpVersion();
                return true;
            }

            return lovVersion && lovVersion !== constants.DEFAULT_VERSION && lovVersion === version;
        }

        updateLovVersion() {
            var version = localStorage.getItem(constants.LS_VERSION);
            //console.log(`Updating LOV version to ${version}`);
            if (version) {
                localStorage.setItem(constants.LS_LOV_VERSION, version);
            }
        }

        loadAdvisorOpVersion() {
            var version = constants.DEFAULT_VERSION;
            this.$http.get("/api/version").then(response => {
                version = <string>response.data;
                localStorage.setItem(constants.LS_VERSION, version)
            }, err => localStorage.setItem(constants.LS_VERSION, version));
        };

        getInvestorLogins(investorId: number, count: number): ng.IHttpPromise<Array<Date>> {
            return this.$http.get("/api/general/getinvestorlogins/" + investorId + "/" + count);
        }

        // #region LOVs
        getLOVs(): ng.IPromise<Array<domains.ILOV>> {

            var deferred = this.$q.defer();

            var cachedLov = localStorage.getItem(constants.LS_LOV);

            // cache exists and it's valid
            if (cachedLov && this.checkLovVersion()) {
                deferred.resolve(<Array<domains.ILOV>>angular.fromJson(cachedLov));
            }
            else {
                //console.log(`Fetching LOV from server`);

                this.$http.get("/api/general/getlovs")
                    .then(response => {
                        localStorage.setItem(constants.LS_LOV, angular.toJson(response.data));
                        // update lov version
                        this.updateLovVersion();
                        deferred.resolve(response.data);
                    }, err => {
                        deferred.reject(`${err.status} ${err.data}`);
                    });
            }

            return <ng.IPromise<Array<domains.ILOV>>>deferred.promise;
        };
        getLOVsByLovType(lovType: number): ng.IHttpPromise<Array<domains.ILOV>> {
            return this.$http.get("/api/general/getlovs/" + lovType);
        };

        // #endregion LOVs

        // #region LINKS
        getLinkTypes(): ng.IHttpPromise<Array<domains.ILinkType>> {
            return this.$http.get("/api/general/getlinktypes");
        };

        getLinkTypeCategories(): ng.IHttpPromise<Array<string>> {
            return this.$http.get("/api/general/getlinktypecategories");
        };

        getLinks(): ng.IHttpPromise<Array<domains.ILink>> {
            return this.$http.get("/api/general/getlinks");
        };
        // #endregion

        // #region EXTERNAL_SYSTEMS
        getExternalSystems(): ng.IHttpPromise<domains.IExternalSystem[]> {
            return this.$http.get("/api/general/getExternalSystems");
        };

        getExternalSystemsByType(type: domains.ExternalSystemType): ng.IHttpPromise<domains.IExternalSystem[]> {
            return this.$http.get(`/api/general/getExternalSystemsByType/${type}`);
        };
        // #endregion


        // #region localstorage for landing page

        set goToLandingPage(value: boolean) {
            localStorage.setItem("gotolandingpage", JSON.stringify(value));
        }
        get goToLandingPage() {
            return JSON.parse(localStorage.getItem("gotolandingpage"));
        }

        // #endregion
    }
    angular.module(Constants.ADVOP_SERVICES).service("generalService", GeneralService);
}